import { Component, OnDestroy, Input, ViewEncapsulation, AfterViewInit, HostListener } from '@angular/core';
import { EmitterService } from '../services/emitter.service';
import { Utility } from "../shared/utility/utility";
import { BannerService } from '../services/banner.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { UserDetailsService } from '../services/user-details.service';
import * as _ from 'underscore';
import { AppDetailsService } from '../services/app-details.services';
import { AjaxService } from '../services/ajax.service';
import { PnpZimplerService } from '../services/pnp-zimpler.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EnvironmentService } from '../shared/services/environment.services';



@Component({
  selector: 'app-jackpot',
  templateUrl: './app-jackpot.component.html',
  styleUrls: ['./app-jackpot.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class AppJackpotComponent implements AfterViewInit, OnDestroy {
  @Input() name: string;
  langCode: any;
  isUserLoggedIn: boolean;
  currentURL_slug;
  userDetail: any;
  viewLang: boolean;
  siteUrlPath: string = environment.siteUrl;
  webisteCode = environment.website_code;
  mediaUrlPath = environment.mediaPath;
  bonusBg;
  windowType: string;
  isCountryAllowed: any;
  destroy$: Subject<boolean> = new Subject<boolean>();
  mappedLanguage;
  constructor(
    private emitterService: EmitterService,
    private utils: Utility,
    private bannerService: BannerService,
    private router: Router,
    private userDetailsService: UserDetailsService,
    private appDetails: AppDetailsService,
    private ajaxService: AjaxService,
    private pnpService:PnpZimplerService,
    private environmentServise:EnvironmentService
  ) {
    this.mappedLanguage = this.environmentServise.getActiveLanguageConfig();
    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(lang => {
      this.langCode = lang;
    });

    this.emitterService.isCountryAllowed$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.isCountryAllowed = data;
    })
    
    
  }

  ngAfterViewInit() {
    this.deviceDetect();
  }

  @HostListener('window:orientationchange') onOrientationChange() {
    this.deviceDetect();
  }
  @HostListener('window:resize') onResize() {
    this.deviceDetect();
  }

  deviceDetect(){
    setTimeout(_ => {
      const ww = document.body.clientWidth;
      if (ww <= 992) {
        this.windowType = "mobile";
        this.bonusBg = this.siteUrlPath + "/" + this.mediaUrlPath + "/bonus_bg-mobile.png";
      } else {
        this.windowType = "desktop";
        this.bonusBg = this.siteUrlPath + "/" + this.mediaUrlPath + "/bonus_bg-desktop.png";
      }
    });
  }

  listClick(item) {
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    let lang = window.location.pathname.substring(1, 3);
    this.langCode = item;
    this.currentURL_slug = window.location.pathname.substring(3);
    if (item && item !== localStorage.getItem("langCode")) {
      this.langCode = item;
      this.bannerService.clearBanners();
      localStorage.setItem("langCode", this.langCode);
      this.emitterService.broadcastLangCode(this.langCode);
      if (this.currentURL_slug.length > 1) {
        this.router.navigate([localStorage.getItem('langCode') + '/' + this.currentURL_slug], { queryParamsHandling: 'preserve' });
        this.langCode = localStorage.getItem('langCode');
      } else if (window.location.pathname.length === 3 && _.contains(this.mappedLanguage, lang)) {
        this.router.navigate([this.langCode]);
      }
      if (!this.isUserLoggedIn) {
        this.utils.reloadPage();
      }
    }
    this.viewLang = false;
  }

  register() {
    /* checking user login status, if user is already logged in, loading the homepage else navigate to registration page  */
    Promise.resolve(this.ajaxService.getLoginStatus()).then(data => {
      if (data['status']) {
        this.appDetails.loadHomepage(this.langCode);
      }
      else {
        this.router.navigate([this.langCode + '/register/step1/'], { queryParams: { prevUrl: window.location.pathname } });
      }
    });

  }

  moveToTrustlyPay(){
    if(this.userDetailsService.checkZimplerDepositOpen()) {
      this.pnpService.openZimplerDeposit()
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
